import { useState, useEffect } from 'react';
import type { InsightObjectAttribute } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-attribute.tsx';
import { AttributeTypeMap } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute-types.tsx';
import type { CmdbObjectAttribute } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';
import type { BBRepoPickerOption } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/picker-options.tsx';

export const getBBRepoValuesFromCmdbObjectAttribute = (
	attribute?: CmdbObjectAttribute,
): BBRepoPickerOption[] => {
	if (attribute && attribute.type === AttributeTypeMap.BitbucketRepo) {
		return attribute.objectAttributeValues.map(
			({ bitbucketRepo: { uuid, name, avatarUrl, url } }) => ({
				uuid,
				name,
				avatarUrl,
				url,
			}),
		);
	}
	return [];
};

export const getBBRepoValues = (attribute?: InsightObjectAttribute): BBRepoPickerOption[] => {
	if (attribute && attribute.type === 'bitbucketRepo') {
		return attribute.bitbucketRepoTypeValues.map(
			({ bitbucketRepo: { uuid, name, avatarUrl, url } }) => ({
				uuid,
				name,
				avatarUrl,
				url,
			}),
		);
	}
	return [];
};

export const useBBRepoValue = (attribute?: InsightObjectAttribute) => {
	const repos = getBBRepoValues(attribute);
	const [value, setValue] = useState<BBRepoPickerOption[]>(repos);

	useEffect(() => {
		setValue(() => getBBRepoValues(attribute));
	}, [attribute]);

	return [value, setValue] as const;
};
